import styled from "styled-components/macro";
import {theme} from "../../styles/theme";

export const Wrapper = styled.div`
  background: ${theme.colors.bgSecondary};
  & > div {
    margin: 0 auto;
    max-width: 1360px;
    padding: 46px 80px;
    display: flex;
    @media (max-width: 930px) {
      padding: 46px 40px;
    }
    @media (max-width: 850px) {
      padding: 46px 20px;
    }
    @media (max-width: 811px) {
      flex-direction: column;
      align-items: center;
    }
  }
`;

export const Content = styled.div`
  margin-left: 64px;
  display: flex;
  flex-direction: column;
  & p {
    margin: 30px 0 24px;
    font-size: 24px;
    color: ${theme.colors.text}
  }
  & div > div {
    margin-right: 64px;
    display: flex;
    flex-direction: column;
    & span {
      font-size: 20px;
    }
  }
  & > div {
    display: flex;
    justify-content: space-between;
  }
  @media (max-width: 811px) {
    margin-top: 30px;
    margin-left: 0;
  }
  @media (max-width: 450px) {
    & div > div {
      margin: 0 0 24px 0;
    }
    & > div {
      & span {
        text-align: center;
      }
      flex-direction: column;
    }
  }
`;